import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";


import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateProduct } from "../api/queries";
import { ProductForm } from "../ui/ProductForm";

export function ProductCreatePage() {
  const nav = useNavigate({ from: "/app/catalog/products/create" });
  const createProduct = useCreateProduct();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ສິນຄ້າ / ເມນູ",
              to: "/app/catalog/products",
            },
            {
              label: "ສ້າງສິນຄ້າ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ສ້າງສິນຄ້າ
            </h2>
            <p className="text-muted-foreground">
              ເລືອກປະເພດ MENU ຫຼື RETAIL ແລະຕື່ມຂໍ້ມູນ. ຫຼັງສ້າງແລ້ວເພີ່ມ variants ໄດ້ທີ່ຫນ້າລາຍລະອຽດ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/catalog/products" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <ProductForm
          onSubmit={async (vals) => {
            try {
              const created = await createProduct.mutateAsync(vals);
              toast.success("ສ້າງສິນຄ້າສຳເລັດ", {
                description: "ສິນຄ້າຖືກສ້າງແລ້ວ",
              });
              nav({
                to: "/app/catalog/products/$id/edit",
                params: { id: created.id },
              });
            } catch {
              // mutation onError shows toast
            }
          }}
          submitting={createProduct.isPending}
          onCancel={() => nav({ to: "/app/catalog/products" })}
          submitLabel="ສ້າງສິນຄ້າ"
        />
      </Main>
    </>
  );
}
